import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { fetchPendingClosedCircles } from 'modules/circles/actions';
import ClosedCirclesView from 'modules/circles/views/ClosedCirclesView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ClosedCirclesPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();

  const closedCirclesListApiCallBody = useMemo(
    () => ({
      circleStatus: 'Pending',
      page: 1,
      limit: 10,
    }),
    [],
  );
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(contexts.closedCircles);
  }, []);

  useEffect(() => {
    const body = {
      data: closedCirclesListApiCallBody,
    };
    dispatch(fetchPendingClosedCircles(body));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <ClosedCirclesView closedCirclesListApiCallBody={closedCirclesListApiCallBody} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ClosedCirclesPage.propTypes = {};

ClosedCirclesPage.defaultProps = {};

export default ClosedCirclesPage;
